export default __webpack_public_path__ + "static/media/cancel-sl.3fd08cfe.jpg";